import app, { Component, } from 'apprun';
import { auth, serializeObject } from './api';
import { areRequiredFieldsAvailable } from './utils';
import PasswordInput from './password-input';

export default class LoginComponent extends Component {
  state = {};

  view = () => <div id="mainDiv">
    <style>{`
      .login_form #password_toggle_icon {
        top: 10px !important;
        transform: none !important;
      }
    `}</style>
    <div class="login_wrapper" style={{ 'max-width': '450px' }}>
      <div class="animate form login_form" style={{ 'z-index': 1050, 'background-color': 'white', padding: '50px' }}>
        <section class="login_content">
          <form id="loginForm" onkeypress={(e) => { if (e.keyCode === 13) {this.run('sign-in', e);} }}>
            <h1>Login Form</h1>
            <div>
              <input name="email" type="text" class="form-control" placeholder="Username" required="" autocomplete="off" />
            </div>
            <br />
            <div class="form-group">
              <PasswordInput id="password" name="password" placeholder="Password" required={true} autocomplete="off" />
            </div>
          </form>
          <div>
            <button class="btn btn-default submit" onclick={e => this.run('sign-in', e)}>Log in</button>
            <a class="reset_pass">Lost your password?</a>
          </div>
        </section>
      </div>
    </div>
    <div class="modal-backdrop show" style={{ opacity: '0.5' }} />
  </div>;

  update = {
    '#login': state => state,

    '#logout': () => {
      auth.signOut();
      document.location.href = '/';
    },

    'sign-in': async (state) => {
      if (areRequiredFieldsAvailable(state, 'loginForm')) {
        const formData = serializeObject(document.getElementById('loginForm'));
        const session = await auth.signIn(formData as { email: string; password: string });
        const user = session.user;
        if (user) {
          app.run('show-message', '😄👌❤️, Welcome, ' + user.email);
          window.location.href = '/';
        }
      } else {
        //TODO: required fileds error message
      }
    }
  };
}

new LoginComponent().mount('rlp-app');
